import { useDynamicConstants } from 'src/services/constants'
import type { PaymentProvider } from '../utils/expireStateUtils'

export const usePaymentMethodAutoRenewable = () => {
  const { data: dConst } = useDynamicConstants()
  const autoRenewableProviders = dConst?.payment?.autoRenewableProviders || []

  return (provider: PaymentProvider | string) =>
    autoRenewableProviders.includes(provider.toString())
}
